// extracted by mini-css-extract-plugin
export var loadedContainer = "preview-indicator-module--loadedContainer--77aa8";
export var loadingContainer = "preview-indicator-module--loadingContainer--e792c";
export var previewContainer = "preview-indicator-module--previewContainer--311c7";
export var textContainer = "preview-indicator-module--textContainer--47d73";